module.exports = __webpack_public_path__ + "static/media/botez-icon.61a932d5.svg";